import { useEffect, useState } from 'react';
// import { curPageProgressIsCompleted } from './Pages/utils';
import { curPageProgressIsCompleted } from './utils';
import { pageProgressMap } from '@/utils/contants/caseSimulation';

const useCaseEntry = (props) => {
    let { params, location, navigate, side = 'web' } = props;
    let { agentId, caseId, sceneId } = params;
    let { simulation, grtAi } = props.store;

    let { reStart, getApiProgress, getPath } = simulation;
    const [loading, setLoading] = useState(true);
    const getGoPath = (path) => {
        let prePath = getPath();
        return `${prePath}/${path}`;
    };
    const afterRestart = () => {
        let path = getGoPath('background');
        // window.location.replace(`${window.location.origin}/agent/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/background`);
        window.location.replace(`${window.location.origin}/agent${path}`);
    };
    const reStartCase = async () => {
        setLoading(true);
        await reStart(caseId, afterRestart);
        setLoading(false);
    };
    //是否答完题
    const hasEventCompleted = (progress) => {
        return curPageProgressIsCompleted(progress, pageProgressMap.task_in_progress);
    };
    const getProgress = async (subPathname) => {
        setLoading(true);
        let goPath = getPath();
        let progress = await getApiProgress(caseId);

        let status = hasEventCompleted(progress);
        //题目已经答完，直接进入结果页
        if (status === 'completed' && subPathname !== 'review-report') {
            // navigate(`/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/event-result`, { replace: true });
            navigate(`${goPath}/event-result`, { replace: true });
        }
        //题目正在进行，并且不在答题页，跳转到答题页
        if (status === 'ing' && subPathname !== 'event') {
            // navigate(`/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/event`, { replace: true });
            navigate(`${goPath}/event`, { replace: true });
        }
        //题目未答完 如果在答题页 不做操作，不在答题页 跳到背景页
        if (status === 'uncompleted') {
            // navigate(`/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/background`, { replace: true });
            navigate(`${goPath}/background`, { replace: true });
        }
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };
    const init = async () => {
        simulation.setCaseId(caseId);
        simulation.setSimulationParams({
            agentId,
            caseId,
            sceneId,
            side
        });
        // simulation.getSceneDetail(sceneId);
        await grtAi.getAgentDetail(agentId);
        let res = await simulation.getCaseInfo(caseId);
        if (!res) {
            return false;
        }

        let subPathname = location.pathname.split('/').slice(-1)[0];
        //这两个页面需要判断是否正在生成，需要轮询调用接口，在对应页面请求了进度接口
        if (subPathname === 'review-report' || subPathname === 'event-result') {
            setLoading(false);
            return;
        }
        simulation.getContent(caseId);
        getProgress(subPathname);
    };
    useEffect(() => {
        init();
    }, []);
    return {
        loading,
        reStartCase
    };
};

export default useCaseEntry;
